import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SpinnerService } from '../../services/spinner.service';
import { DownloadService } from '../../services/download.service';
import { SnackbarService } from '../../services/snackbar.service';
import {
  AportacionDIEstadoControllerService,
  AportacionDIPoseedorControllerService,
  OperacionGestionControllerService,
  ResiduoEnvaseFilterDTO,
  SolicitudNimaGestoresDTO,
  AportacionDIEstadoDTO,
  GestoresResiduosControllerService,
  CodigoOperacionFilterDTO,
  AportacionDIAcuerdosGestoresDTO,
  AportacionDiAcuerdosGestoresControllerService,
  CodigoLerFilterDTO,
  CodigoLerControllerService,
  AportacionDIAcuerdosGestoresPayloadDTO,
  AportacionDIPoseedorDTO,
  AportacionDIPoseedorPayloadDTO,
  AportacionDITarifaImporteDTO,
  CodigoLerDTO,
  PageDTOCodigoLerDTO,
  ParametrosControllerService,
  PoseedorControllerService,
  PoseedorDTO,
  ResiduoEnvaseControllerService,
  ResiduoEnvasePayloadDTO,
  SolicitudCodigoLerDTO,
  SolicitudNimaPoseedorDTO,
} from 'api-rest';
import { catchError, Observable, of, Subscription, tap } from 'rxjs';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DocumentService } from '../../services/document.service';
import {ValidateService} from "../../services/validate.service";
import moment from 'moment';
import swal from 'sweetalert2';
import { ManagersAgreementsContributionsDisImageDialogComponent } from '../managers-agreements-contributions-dis-image-dialog/managers-agreements-contributions-dis-image-dialog.component';
import { ManagersAgreementsContributionsDisDeclineDialogComponent } from '../managers-agreements-contributions-dis-cancel-dialog/managers-agreements-contributions-dis-cancel-dialog.component';
import { ManagersAgreementsContributionsDisPreviewDialogComponent } from './managers-agreements-contributions-dis-preview-dialog.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-managers-agreements-contributions-dis-dialog',
  templateUrl: './managers-agreements-contributions-dis-dialog.component.html',
  styleUrls: ['./managers-agreements-contributions-dis-dialog.component.scss'],
})
export class ManagersAgreementsContributionsDisDialogComponent implements OnInit {
  estadoArray: AportacionDIEstadoDTO[] = [];
   codigoLerArray: CodigoLerDTO[] = [];
   documentoArray: any[] = [];
   residuoArray: any[] = [];
   descripcionEnvaseArray: any[] = [];
   gestionArray: any[] = [];
   nimaPoseedorArray: any[] = [];
   nimaGestorArray: any[] = [];
   entityRoles: any[] = [];
 
   modelForm!: FormGroup;
   uipathForm!: FormGroup;
   subscriptions: Subscription[] = [];
   roleEntities: any[] = [];
   documento: File | undefined;
   titulo: any;
   isGestor = false;
   isPoseedor = false;
   edicion = false;
   alta = false;
   estado: Number = 1;
   cargaCombos: boolean = true;
 
   tipoAcceso: string | null = null;
   pageNumber: number = 0;
   pageSize: number = 100;
   recordsTotal: number = 0;
   fechaLimite: Date | undefined;
   poseedorInfo: PoseedorDTO | undefined;
   creacionResiduoEnvase: boolean = false;
   codigosLerEndpoint : CodigoLerDTO[] = [];
  private poseedoresRequestSeq = 0;
  private codigoLerRequestSeq = 0;
  private codigoLerLockedByUser = false;
  listaGestoresByUser = this.environment.urlBackCore + 'api/v1/acuerdo-indirecto/gestores/byUser';
  private readonly bidonMetalCodigoLer: CodigoLerDTO = {
    codigo: 'LER23',
    descripcion: 'Envases peligrosos de metal tipo Bidón',
    id: 45,
    peligrosidad: true,
    poseedores: true,
    ptosRecogida: false,
    sddrCA: true,
    tipoCodigo: '15 01 10*',
  };
  private readonly bidonPlasticoCodigoLer: CodigoLerDTO = {
    codigo: 'LER24',
    descripcion: 'Envases peligrosos de plástico tipo Bidón',
    id: 46,
    peligrosidad: true,
    poseedores: true,
    ptosRecogida: false,
    sddrCA: true,
    tipoCodigo: '15 01 10*',
  };
 
   operacionGestionEndpoint: string = this.environment.urlBackPoseedores + `api/v1/poseedores/operacion-gestion/codigo-operacion`;
   updateList: boolean = false;
   defaultOperacionesGestionParameters: any = {codigoLer: [null], poseedores: true}
 
   get styleEstadoAportaciones(): { 'background-color': string; 'color': string } {
     const estadoId = this.aportacion?.poseedorOrGestor.estado.id || this.aportacion?.estado?.id;
     console.log(estadoId);
     switch (estadoId) {
       case 1: return { 'background-color': '#F49D33', 'color': '#ffffff' };
       case 2: return { 'background-color': '#F49D33', 'color': '#ffffff' };
       case 3: return { 'background-color': '#86BC25', 'color': '#ffffff' };
       case 4: return { 'background-color': '#773E90', 'color': '#ffffff' };
       case 5: return { 'background-color': '#A7A6A6', 'color': '#ffffff' };
       case 10: return { 'background-color': '#5FC3E1', 'color': '#ffffff' };
       case 7: return { 'background-color': '#B80F61', 'color': '#ffffff' };
       case 8: return { 'background-color': '#080C35', 'color': '#ffffff' };
       case 9: return { 'background-color': '#004A99', 'color': '#ffffff' };
       default: return { 'background-color': '#ffffff', 'color': '#080C35' };
     }
   }
     get iconEstado() {
     return this.aportacion?.poseedorOrGestor.estado || this.aportacion?.estado ?.id === 3 ? 'check_circle' : 'warning_amber';
   }
   constructor(
     @Inject('environment') private environment: any,
     private formBuilder: FormBuilder,
     private router: Router,
    private http: HttpClient,
     public dialog: MatDialog,
     public spinnerSrv: SpinnerService,
     private snackBarSrv: SnackbarService,
    private dialogRef: MatDialogRef<ManagersAgreementsContributionsDisDialogComponent>,
     private estadoAportacionesService: AportacionDIEstadoControllerService,
     private aportacionesDiService: AportacionDIPoseedorControllerService,
     private downloadService: DownloadService,
     private documentService: DocumentService,
     @Inject('EmpusaAuthenticationService')
     private authService: EmpusaAuthenticationService,
     @Inject(MAT_DIALOG_DATA) public aportacion: AportacionDIPoseedorDTO | any,
     private operacionGestionControllerService: OperacionGestionControllerService,
     private parametrosControllerService: ParametrosControllerService,
     private residuoEnvaseControllerSrv: ResiduoEnvaseControllerService,
     private poseedorControllerSrv: PoseedorControllerService,
     private codigoLerControllerService: CodigoLerControllerService,
     private aportacionDiAcuerdosGestoresService: AportacionDiAcuerdosGestoresControllerService,
   ) {
    if (!this.aportacion) {
      this.aportacion = {};
    }

    // Normalize input shape so both "detalle" and "nueva aportacion" flows work.
    if (!this.aportacion.poseedorOrGestor) {
      this.aportacion.poseedorOrGestor = {};
    }

    if (this.aportacion.poseedorOrGestor.poseedor == null && this.aportacion.poseedor != null) {
      this.aportacion.poseedorOrGestor.poseedor = this.aportacion.poseedor;
    }

    if (this.aportacion.poseedorOrGestor.gestorResiduo == null && this.aportacion.gestorResiduo != null) {
      this.aportacion.poseedorOrGestor.gestorResiduo = this.aportacion.gestorResiduo;
    }

    // Keep root fields aligned when payload comes nested in poseedorOrGestor.
    if (this.aportacion.poseedor == null && this.aportacion.poseedorOrGestor.poseedor != null) {
      this.aportacion.poseedor = this.aportacion.poseedorOrGestor.poseedor;
    }

    if (this.aportacion.gestorResiduo == null && this.aportacion.poseedorOrGestor.gestorResiduo != null) {
      this.aportacion.gestorResiduo = this.aportacion.poseedorOrGestor.gestorResiduo;
    }

    const estadoRaw = this.aportacion?.estado;
    const estadoNormalizado =
      estadoRaw && estadoRaw.id != null
        ? estadoRaw
        : { id: estadoRaw ?? 1, descripcion: 'Abierta' };

    if (!this.aportacion.poseedorOrGestor.estado) {
      this.aportacion.poseedorOrGestor.estado = estadoNormalizado;
    }
    if (!this.aportacion.estado) {
      this.aportacion.estado = estadoNormalizado;
    }

     this.tipoAcceso = aportacion?.tipoAcceso ?? null;
 
     if (aportacion?.poseedor) {
       this.isPoseedor = true;
       this.comboCodigoLer();
     } else {
       this.isGestor = true;
     }
     
     this.inicializarForm();
     this.inicializarFormUipath();
     this.comboCodigoLer();
     this.defaultOperacionesGestionParameters = {codigoLer: [this.modelForm.get('codigoLer')?.value?.id ?? null], poseedores: true};
   }
 
   ngOnInit() {
     this.cargaInicial();
     if (this.isEdicionMode() && this.showUipathData()) {
       this.dialogRef.updateSize('1425px', undefined);
     }
   }
 
comboCodigoLer() {
  const rawFechaAceptacion = this.modelForm?.get('fechaAceptacion')?.value ?? this.aportacion?.fechaAceptacion;
  const fechaAceptacion = rawFechaAceptacion ? moment(new Date(rawFechaAceptacion)).format('YYYY-MM-DD') : undefined;

  const gestor = this.modelForm?.get('nimaGestor')?.value ?? this.aportacion?.gestorResiduo;
  const poseedor = this.modelForm?.get('poseedor')?.value ?? this.aportacion?.poseedor;

  const gestorId = gestor?.id ?? gestor?.gestorId ?? gestor?.idGestor;
  const poseedorId = poseedor?.id ?? poseedor?.poseedorId ?? poseedor?.idPoseedor;

  if (!fechaAceptacion || !gestorId || !poseedorId) {
    const hasCurrentCodigoLer = !!this.modelForm?.get('codigoLer')?.value;
    if (!hasCurrentCodigoLer) {
      this.codigoLerArray = [];
      this.codigosLerEndpoint = [];
    }
    return;
  }

  const backendFilter = {
    fechaAceptacion,
    gestorId,
    poseedorId,
    origenSDDRCA: this.modelForm?.get('esAportacionSDDRCA')?.value ?? this.aportacion?.esAportacionSDDRCA,
  };

  const currentRequestSeq = ++this.codigoLerRequestSeq;
  this.aportacionDiAcuerdosGestoresService.codigoLer(backendFilter).subscribe({
    next: (data: any[]) => {
      if (currentRequestSeq !== this.codigoLerRequestSeq) {
        return;
      }
      this.codigoLerArray = data ?? [];
      this.codigosLerEndpoint = this.codigoLerArray;
    },
    error: () => {
      if (currentRequestSeq !== this.codigoLerRequestSeq) {
        return;
      }
      this.codigoLerArray = [];
      this.codigosLerEndpoint = [];
    },
  });
}
   inicializarForm() {
     if (this.aportacion?.esAportacionSDDRCA) {
       this.aportacion.origen = 'SDDRCA';
     } else if (this.aportacion && !this.aportacion.origen) {
       this.aportacion.origen = 'POSEEDOR';
     }
     this.aportacion.fechaAceptacion;
     //Si es nueva aportacion, inicializar la fecha aceptacion con la fecha actual, sino, mantenerla vacia
     if(this.aportacion.id){
       //detalle de aportacion
       this.aportacion.fechaAceptacion = this.aportacion.fechaAceptacion;
     }else{
       //nueva aportacion
       this.aportacion.fechaAceptacion = this.aportacion.fechaAceptacion ?? null;
     }
     if(this.aportacion.gestorResiduo == null && this.aportacion.nimaGestor != null && this.aportacion.nimaGestor != ''){
       this.aportacion.gestorResiduo = {
         nima: this.aportacion.nimaGestor
       }
     }
     if (this.aportacion.gestorResiduo == null && this.aportacion.nimaGestor != null && this.aportacion.nimaGestor != '') {
       this.aportacion.gestorResiduo = {
         nima: this.aportacion.nimaGestor
       }
     }
     this.modelForm = this.formBuilder.group({
       id: [{ value: this.aportacion?.id }],
       documentoIdentificacion: [
         { value: this.aportacion?.documentoIdentificacion, disabled: false },
         { validators: Validators.compose([Validators.required, Validators.maxLength(255)]) },
       ],
       fechaAceptacion: [
         { value: this.aportacion?.fechaAceptacion, disabled: false },
         { validators: Validators.compose([Validators.required, this.customValidator()]) },
       ],
       fechaAportacion: [
         { value: this.aportacion?.fechaAportacion, disabled: true },
       ],
       estado: [{ value: this.aportacion?.poseedorOrGestor.estado || this.aportacion?.estado , disabled: false }],
 
       poseedor: [
         { value: this.aportacion?.poseedor, disabled: false },
         { validators: Validators.compose([Validators.required]) },
       ],
       nimaGestor: [
         { value: this.aportacion?.gestorResiduo, disabled: false },
         { validators: Validators.compose([Validators.required]) },
       ],
 
       autofactura: [{ value: null, disabled: false }],
       documento: [{ value: this.aportacion?.documento, disabled: false }],
       
 
       codigoLer: [
         { value: this.aportacion?.codigoLer, disabled: false },
         { validators: Validators.compose([Validators.required]) },
       ],
       gestorResiduo: [
         { value: this.aportacion?.gestorResiduo, disabled: false },
       ],
       operacionGestion: [
         { value: this.aportacion?.operacionGestion, disabled: false },
         { validators: Validators.compose([Validators.required]) },
       ],
 
       cantidadGestionada: [
         { value: this.aportacion?.cantidadGestionada, disabled: false },
         { validators: Validators.compose([Validators.required, Validators.min(0.000000001)]) },
       ],
       esAportacionSDDRCA: [
         { value: this.aportacion?.esAportacionSDDRCA, disabled: false },
       ],
       importeTotal: [{ value: null, disabled: true }],
       tarifaAplicada: [{ value: null, disabled: true }],
       confirmacionDatos: [
         { value: null, disabled: false },
         //{ validators: Validators.compose([Validators.required]) }
       ],
       esCreadoPoseedor: [{ value: this.isPoseedor, disabled: false },],
       subirDocumentoOnEdit: [
         { value: false, disabled: false },
         //  { validators: Validators.compose([Validators.required]) },
       ],
     });
    //if (this.aportacion?.poseedorOrGestor?.estado?.id === 7 || this.aportacion?.poseedorOrGestor?.estado?.id === 1 || this.aportacion?.estado?.id === 7 || this.aportacion?.estado?.id === 1 || this.aportacion?.estado === 7 || this.aportacion?.estado === 1) {
      this.comboCodigoLer();
    //}
     this.modelForm.get('operacionGestion')?.valueChanges.subscribe((val) => {
       // Sólo cuando la selección la hace el usuario (los cambios programáticos no marcan el control como dirty)
       if (!val || !this.modelForm.get('operacionGestion')?.dirty) return;
       this.avisarCombinacionBidon(val);
     });
     const codigoLerControl = this.modelForm.get('codigoLer');
     codigoLerControl?.valueChanges.subscribe((val) => {
       if (this.creacionResiduoEnvase === false && ((this.aportacion.poseedorOrGestor.estado.id === 7 || this.aportacion.poseedorOrGestor.estado.id === 1) || (this.aportacion?.estado?.id === 7 || this.aportacion?.estado?.id === 1))) {
         // Sólo resetear operacionGestion si el cambio proviene del usuario
         if (codigoLerControl?.dirty) {
           this.modelForm.controls['operacionGestion'].reset();
         }
       }
     });
     this.modelForm.get('poseedor')?.valueChanges.subscribe((val) => {
       if ((this.aportacion.poseedorOrGestor.estado.id === 7 || this.aportacion.poseedorOrGestor.estado.id === 1) || (this.aportacion?.estado?.id === 7 || this.aportacion?.estado?.id === 1)) {
         if (this.aportacion.poseedor !== null && this.aportacion.poseedor !== undefined && this.aportacion.poseedor !== '') {
           this.poseedorInfo = this.aportacion.poseedor;
         }
         else if (this.modelForm.get('poseedor')?.value !== null && this.modelForm.get('poseedor')?.value !== undefined && this.modelForm.get('poseedor')?.value !== '' && this.modelForm.get('poseedor')?.value.id !== null && this.modelForm.get('poseedor')?.value.id !== undefined && this.modelForm.get('poseedor')?.value.id !== '') {
           this.poseedorInfo = this.modelForm.get('poseedor')?.value;
         }
           
       }
       
 
     });
     if ((this.aportacion?.poseedorOrGestor.estado?.id === 7 || this.aportacion?.poseedorOrGestor.estado?.id === 1 || this.aportacion?.estado?.id === 7 || this.aportacion?.estado?.id === 1) && this.aportacion?.poseedor && this.aportacion.esCreadoPoseedor !== false) {
         if (this.aportacion.poseedor !== null && this.aportacion.poseedor !== undefined && this.aportacion.poseedor !== '') {
           this.poseedorInfo = this.aportacion.poseedor;
         }
         else if (this.modelForm.get('poseedor')?.value !== null && this.modelForm.get('poseedor')?.value !== undefined && this.modelForm.get('poseedor')?.value !== '' && this.modelForm.get('poseedor')?.value.id !== null && this.modelForm.get('poseedor')?.value.id !== undefined && this.modelForm.get('poseedor')?.value.id !== '') {
           this.poseedorInfo = this.modelForm.get('poseedor')?.value;
           //this.poseedorInformacion().subscribe();
         }
     }
     //this.valueChangeCodigoLer();
   }

  private avisarCombinacionBidon(operacion: any): void {
    if (![1, 7, 10].includes(this.getCurrentEstadoId() as number)) return;
    const lerId = this.modelForm.controls['codigoLer'].value?.id;
    let material: string;
    let codigoLerBidon: 'LER23' | 'LER24';
    if (operacion.codigo === 'R0309' && lerId === 11) {
      material = 'plástico';
      codigoLerBidon = 'LER24';
    } else if (operacion.codigo === 'R0404' && lerId === 12) {
      material = 'metal';
      codigoLerBidon = 'LER23';
    } else {
      return;
    }
    Swal.fire({
      text: `Esta selección de datos se considera un “15 01 10* - Envase peligroso de ${material} de tipo Bidón”. Si acepta, el código LER se cambiará por el de bidón.`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.cambiarLerBidon(codigoLerBidon);
      }
    });
  }

  private cambiarLerBidon(codigoLerBidon: 'LER23' | 'LER24'): void {
    const bidon = this.getOrInsertBidonCodigoLer(codigoLerBidon);
    // Sin emitir evento para que no se resetee la operación de gestión seleccionada
    this.creacionResiduoEnvase = true;
    this.modelForm.controls['codigoLer'].setValue(bidon, { emitEvent: false });
    this.creacionResiduoEnvase = false;
    this.defaultOperacionesGestionParameters = {codigoLer: [bidon.id ?? null], poseedores: true};
    this.updateList = !this.updateList;
    this.cargarTarifaImporte();
  }
   guardarPrevision(residuo: ResiduoEnvasePayloadDTO | any,id?:number): void {
     this.spinnerSrv.loadingShow();
     this.residuoEnvaseControllerSrv.create3(residuo).subscribe({
       next: (response: PoseedorDTO) => {
         this.spinnerSrv.loadingHide();
         this.residuoEnvaseControllerSrv
           .comprobarNimaGestor(response.id!)
           .subscribe({
             next: (resultado: any) => {
               residuo.existeNima = resultado;
               /*if (resultado === false) {
                 let mensaje = 'Este gestor no está registrado en ENVANET. Le recomendamos que le informe de que debe registrarse, en caso de delegarle el suministro de información por la correcta gestión de sus envases.';
                 this.snackBarSrv.showSnackBar(
                   mensaje,
                   'warning'
                 );
               }*/
               
               //Reiniciar formulario: evitar que el valueChanges borre operacionGestion
               this.creacionResiduoEnvase = true;
               this.buscaCodigoLer(
                 this.modelForm.value?.fechaAceptacion,
                 this.modelForm.value?.nimaGestor,
                 this.modelForm.value?.poseedor,
                 false
               );
               this.modelForm.controls['codigoLer'].setValue({ id: id }, { emitEvent: false });
 
               this.modelForm.markAsPristine();
               this.modelForm.markAsUntouched();
               this.creacionResiduoEnvase = false;
             },
             error: (error: any) => {},
           });
       },
       error: (err) => {
         this.spinnerSrv.loadingHide();
         /*this.snackBarSrv.showSnackBar(
           'Ha ocurrido un error al guardar la previsión de residuos',
           'error'
         );*/ 
       },
     });
   }
  private getOrInsertBidonCodigoLer(codigo: 'LER23' | 'LER24'): CodigoLerDTO {
    const fallback = codigo === 'LER23' ? this.bidonMetalCodigoLer : this.bidonPlasticoCodigoLer;
    const existente =
      this.codigosLerEndpoint?.find((x: any) => x?.codigo === codigo) ||
      this.codigoLerArray?.find((x: any) => x?.codigo === codigo);

    if (existente) {
      return existente;
    }

    this.codigoLerArray = [...(this.codigoLerArray ?? []), fallback];
    this.codigosLerEndpoint = [...(this.codigosLerEndpoint ?? []), fallback];
    return fallback;
  }

  private isBidonCodigoLer(codigoLer: any): boolean {
    const codigoActualFormulario = this.modelForm?.get('codigoLer')?.value?.codigo;
    const codigo = codigoLer?.codigo ?? codigoActualFormulario;
    return codigo === 'LER23' || codigo === 'LER24';
  }

   poseedorInformacion() {
     this.spinnerSrv.loadingShow();
     return this.poseedorControllerSrv.getById2(this.modelForm.controls['poseedor'].value?.id).pipe(
       tap((response) => {
         this.spinnerSrv.loadingHide();
         this.poseedorInfo = response;
       }),
       catchError((err) => {
         this.spinnerSrv.loadingHide();
         /*this.snackBarSrv.showSnackBar('Ha ocurrido un error al cargar el poseedor', 'error');*/
         return of(null);
       })
     );
   }
   validarOperacionGestion( residuo: ResiduoEnvasePayloadDTO | any,id?:number) {
        if (this.isBidonCodigoLer(residuo?.codigoLer)) {
          this.creacionResiduoEnvase = true;
          this.buscaCodigoLer(
            this.modelForm.value?.fechaAceptacion,
            this.modelForm.value?.nimaGestor,
            this.modelForm.value?.poseedor,
            false
          );
          this.modelForm.controls['codigoLer'].setValue({ id: id ?? residuo?.codigoLer?.id }, { emitEvent: false });
          this.modelForm.markAsPristine();
          this.modelForm.markAsUntouched();
          this.creacionResiduoEnvase = false;
          return;
        }
         if (
           this.poseedorInfo?.residuosEnvase &&
           this.poseedorInfo?.residuosEnvase?.length > 0
         ) {
           let observables: any[] = [];
     
           let residuosFiltrados = this.poseedorInfo?.residuosEnvase.filter(
             (x: any) => x.anioDatos == new Date().getFullYear()
           );
           if (residuosFiltrados?.length > 0) {
             const existe = residuosFiltrados.find(
               (x) =>
                 x.anioDatos === new Date().getFullYear() &&
                 x.codigoLer?.id === id &&
                 x.operacionGestion?.id ===
                 this.modelForm.get('operacionGestion')?.value?.id &&
                 x.nimaGestor === this.modelForm.get('nimaGestor')?.value?.nima &&
                 x.poseedor?.id ==
                 this.modelForm.get('poseedor')?.value?.id &&
                 x.suministradorInformacion ===
                 'Poseedor'
             );
           
           if (existe) {
             /*this.snackBarSrv.showSnackBar(
               'Ya existe la previsión de residuos de envases introducida',
               'error'
             );*/
             // Evitar que el valueChanges borre operacionGestion en este setValue programático
             this.creacionResiduoEnvase = true;
             this.buscaCodigoLer(
               this.modelForm.value?.fechaAceptacion,
               this.modelForm.value?.nimaGestor,
               this.modelForm.value?.poseedor,
               false
             );
             this.modelForm.controls['codigoLer'].setValue({ id: id }, { emitEvent: false });
             this.creacionResiduoEnvase = false;
           }else {
             this.guardarPrevision(residuo,id);
           }
           }  
     
         } else {
           this.guardarPrevision(residuo,id);
         }
   }
   assignEvents() {
     const sub = this.modelForm.controls[
       'fechaAceptacion'
     ].valueChanges.subscribe((val) => {
       if (val != null) {
        const fechaControl = this.modelForm.get('fechaAceptacion');
        if (fechaControl?.dirty) {
          this.codigoLerLockedByUser = false;
          this.modelForm.get('poseedor')?.setValue(null, { emitEvent: false });
          this.nimaPoseedorArray = [];
        }
         this.buscarNimaGestor(val, this.modelForm.value?.poseedor);
         this.buscarNimaPoseedor(val, this.modelForm.value?.nimaGestor);
         this.buscaCodigoLer(
           val,
           this.modelForm.value?.nimaGestor,
           this.modelForm.value?.poseedor
         );
         //this.gestionArray = [];
       }
 
     });
     const sub2 = this.modelForm.controls['poseedor'].valueChanges.subscribe(
       (val) => {
         if(this.modelForm.value?.fechaAceptacion != null){
          if (this.modelForm.get('poseedor')?.dirty) {
            this.codigoLerLockedByUser = false;
          }
           this.buscarNimaGestor(this.modelForm.value?.fechaAceptacion, val);
           this.buscaCodigoLer(
             this.modelForm.value?.fechaAceptacion,
             this.modelForm.value?.nimaGestor,
             val
           );
         }
         
       }
     );
     const sub3 = this.modelForm.controls['nimaGestor'].valueChanges.subscribe(
       (val) => {
         if(this.modelForm.value?.fechaAceptacion != null){
          const nimaGestorControl = this.modelForm.get('nimaGestor');
          if (nimaGestorControl?.dirty) {
            this.codigoLerLockedByUser = false;
            this.modelForm.get('poseedor')?.setValue(null, { emitEvent: false });
            this.nimaPoseedorArray = [];
          }
           this.buscarNimaPoseedor(this.modelForm.value?.fechaAceptacion, val);
           this.buscaCodigoLer(
             this.modelForm.value?.fechaAceptacion,
             val,
             this.modelForm.value?.poseedor
           );
         }
       }
     );
     this.subscriptions.push(sub);
     this.subscriptions.push(sub2);
     this.subscriptions.push(sub3);
   }
 
   inicializarFormUipath() {
     //if (this.aportacion?.id) {
       //this.aportacion.fechaAceptacionUipath = this.aportacion.fechaAceptacionUipath ?? new Date().toISOString();
       let gestorUipath;
       if(this.aportacion?.gestorResiduoReferenceUipath){
         gestorUipath = `${this.aportacion?.gestorResiduoReferenceUipath.nima || ''}${this.aportacion?.gestorResiduoReferenceUipath.razonSocial ? ' - ' + this.aportacion?.gestorResiduoReferenceUipath.razonSocial : ''}${this.aportacion?.gestorResiduoReferenceUipath.centro ? ' - ' + this.aportacion?.gestorResiduoReferenceUipath.centro : ''}`;
       }else if(this.aportacion?.nimaGestorUipath){
         gestorUipath = this.aportacion?.nimaGestorUipath;
       }
       let poseedorUipath;
       if(this.aportacion?.poseedorReferenceUipath){
         poseedorUipath =  `${this.aportacion?.poseedorReferenceUipath.nima} - ${this.aportacion?.poseedorReferenceUipath.razonSocial} - ${this.aportacion?.poseedorReferenceUipath.denominacionCentro}`;
       }else if(this.aportacion?.nimaPoseedorUipath){
         poseedorUipath = this.aportacion?.nimaPoseedorUipath;
       }
       let codLerUipath;
       if(this.aportacion?.codigoLerReferenceUipath){
         codLerUipath =  `${this.aportacion?.codigoLerReferenceUipath.tipoCodigo} - ${this.aportacion?.codigoLerReferenceUipath.descripcion}`;
       }else if(this.aportacion?.codigoLerUipath || this.aportacion?.descripcionCodigoLerUipath){
         codLerUipath = `${this.aportacion?.codigoLerUipath} - ${this.aportacion?.descripcionCodigoLerUipath}`;
       }
       let operUipath;
       if(this.aportacion?.operacionGestionReferenceUipath){
         operUipath =  `${this.aportacion?.operacionGestionReferenceUipath.codigo} - ${this.aportacion?.operacionGestionReferenceUipath.descripcion}`;
       }else if(this.aportacion?.codigoOperacionUipath || this.aportacion?.descripcionOperacionUipath){
         operUipath = `${this.aportacion?.codigoOperacionUipath} - ${this.aportacion?.descripcionOperacionUipath}`;
       }
       this.uipathForm = this.formBuilder.group({
         id: [{ value: this.aportacion?.id }],
         documentoIdentificacionUipath: [ { value: this.aportacion?.documentoIdentificacionUipath, disabled: true }],
         fechaAceptacionUipath: [{ value: this.aportacion?.fechaAceptacionUipath, disabled: true }],
         poseedorUipath: [{ value: poseedorUipath, disabled: true }],
         nimaGestorUipath: [{ value: gestorUipath, disabled: true }],
         codigoLerUipath: [ { value: codLerUipath, disabled: true }],
         operacionGestionUipath: [  { value: operUipath,  disabled: true }],
         cantidadGestionadaUipath: [{ value: this.aportacion?.cantidadGestionadaUipath, disabled: true }],
       });
 
       this.uipathForm.disable();
     //}
   }
  
   
   cargaInicial() {
     this.roleEntities = (this.authService.user as any).roleEntities;
     if (this.aportacion?.id) {
       this.titulo = 'Editar aportación de DI/FS';
       this.edicion = true;
     } else {
       this.titulo = 'Alta de aportación de DI/FS';
       this.edicion = false;
     }
 
     this.cargaCombos = true;
     if (this.isOnlyBackForEnvaloraGestorPdteRevision()) {
       this.modelForm.disable();
       this.cargaCombos = false;
     }
     if (this.isOnlyBackState()) {
       this.modelForm.disable();
       this.cargaCombos = false;
     }
     if (this.isCanceladaState()) {
       this.modelForm.disable();
       this.cargaCombos = false;
     }
     if (this.isRevisadaState()) {
       this.modelForm.disable();
       this.cargaCombos = false;
     }
     if (this.isAiGestorSoloReadOnly()) {
       this.modelForm.disable();
       this.cargaCombos = false;
     }
     if (this.isAutofactRevisadaReadOnly()) {
       this.modelForm.disable();
       this.cargaCombos = false;
     }
     if (this.isCorreccionEnvaloraState() && !this.gestorEnvaloraCanEditAportacion()) {
       this.modelForm.disable();
       //this.cargaCombos = false;
     }
     if (!this.canSaveAll()) {
       if(!this.canUpdateEstadoPdteRevision() && !this.canAccessRevisarAportacion() && !this.gestorEnvaloraCanEditAportacion()){
         this.modelForm.disable();
         this.cargaCombos = false;
       }else{
         if(this.canAccessRevisarAportacion() && !this.gestorEnvaloraCanEditAportacion()){
           this.modelForm.get('confirmacionDatos')?.setValidators(Validators.compose([Validators.required]));
           this.modelForm.get('confirmacionDatos')?.updateValueAndValidity();
         }else{
           this.modelForm.get('confirmacionDatos')?.disable();
         }
         
       }
     }
 
     if (this.gestorEnvaloraCanEditAportacion()) {
       this.modelForm.get('subirDocumentoOnEdit')?.setValidators(Validators.compose([Validators.required]));
       this.modelForm.get('subirDocumentoOnEdit')?.updateValueAndValidity();
     } else {
       this.modelForm.get('subirDocumentoOnEdit')?.clearValidators();
       this.modelForm.get('subirDocumentoOnEdit')?.updateValueAndValidity();
     }
 
     this.estadoAportacionesService
       .findAll14()
       .subscribe((estados) => (this.estadoArray = estados));
     const rolesGestor = this.roleEntities?.filter(
       (roleEntity) => roleEntity.role == 'PO-GESTOR'
     );
     const rolesPoseedor = this.roleEntities?.filter(
       (roleEntity) => roleEntity.role == 'PO-POSEEDOR'
     );
     if(this.cargaCombos && this.modelForm.value?.fechaAceptacion != null){
 
       this.buscarNimaGestor(
         this.modelForm.value?.fechaAceptacion,
         this.modelForm.value?.poseedor
       );
       this.buscarNimaPoseedor(
         this.modelForm.value?.fechaAceptacion,
         this.modelForm.value?.nimaGestor
       );
       this.buscaCodigoLer(
         this.modelForm.value?.fechaAceptacion,
         this.modelForm.value?.nimaGestor,
         this.modelForm.value?.poseedor,
         false
       );
       this.buscarFechaLimite()
     } else {
       //La aportacion no se va a editar, por lo que no tiene sentido cargar los combos con todos los datos disponibles
       //Se cargan los datos con lo que tiene el detalle
       if (this.aportacion?.poseedor) {
         this.nimaPoseedorArray.push(this.aportacion?.poseedor);
         this.setItemSelected('poseedor', 'id', this.nimaPoseedorArray, false);
       }
       if (this.aportacion?.gestorResiduo) {
         this.nimaGestorArray.push(this.aportacion?.gestorResiduo);
         this.setItemSelected('nimaGestor', 'nima', this.nimaGestorArray, false);
       }
       if (this.aportacion?.codigoLer) {
         this.codigoLerArray.push(this.aportacion?.codigoLer);
         this.setItemSelected('codigoLer', 'id', this.codigoLerArray, false);
       }
       if (this.aportacion?.operacionGestion) {
         this.gestionArray.push(this.aportacion?.operacionGestion);
         this.setItemSelected('operacionGestion', 'id', this.gestionArray, false);
       }
       this.cargarTarifaImporte();
     }
 
     //this.buscarGestorResiduos();
 
     this.updateDisableField('documentoIdentificacion', false);
     this.updateDisableField('fechaAceptacion');
     this.updateDisableField('cantidadGestionada');
     this.updateDisableField('operacionGestion');
     if(this.edicion){
       // this.modelForm.get('esAportacionSDDRCA')?.disable();
     }
 
     if(this.cargaCombos){
       this.assignEvents();
       this.valueChangeCodigoLer();
       this.valueChangeCantidadGest();
     }

     this.logFooterButtonDiagnostics();
   }

  private logFooterButtonDiagnostics(): void {
    const estadoId = this.getCurrentEstadoId();
    const estadoDescripcion =
      this.aportacion?.poseedorOrGestor?.estado?.descripcion ??
      this.aportacion?.estado?.descripcion ??
      '';

    console.group('[Aportaciones DI/FS] Diagnostico botones footer');
    console.log('AportacionId:', this.aportacion?.id ?? null);
    console.log('Estado detectado:', {
      id: estadoId,
      descripcion: estadoDescripcion,
      isPdteRevisionState: this.isPdteRevisionState(),
      isAutofactRevisadaReadOnly: this.isAutofactRevisadaReadOnly(),
    });
    console.log('Permisos/flags:', {
      canAccessRevisarAportacion: this.canAccessRevisarAportacion(),
      canAccessDeleteAportacion: this.canAccessDeleteAportacion(),
      canSaveAll: this.canSaveAll(),
      canAccessAcceptAportacion: this.canAccessAcceptAportacion(),
      canAccessCancelAportacion: this.canAccessCancelAportacion(),
      gestorEnvaloraCanEditAportacion: this.gestorEnvaloraCanEditAportacion(),
      edicion: this.edicion,
    });
    console.log('Roles cargados:', this.roleEntities?.map((x: any) => x?.role));
    console.groupEnd();
  }
 
   /*buscarInicialGestor(): Observable<any> {
     return this.gestorResiduos
       .getById3(this.aportacion?.gestorResiduo?.id)
       .pipe(
         tap((res) => {
           this.aportacion.gestorResiduo = res;
         })
       );
   }
 
   buscarInicialPoseedor(): Observable<any> {
     return this.poseedorService
       .getById2(this.aportacion?.poseedor?.id)
       .pipe(tap((res) => (this.aportacion.poseedor = res)));
   }*/
 
   updateDisableField(field: any, alsoRevisada: boolean = true): void {
     if (this.aportacion.poseedorOrGestor.estado) {
       if (!this.canAccessEditEstado() && (!alsoRevisada || (alsoRevisada && !this.canUpdateEstadoPdteRevision())) && (!this.gestorEnvaloraCanEditAportacion)) {
         this.modelForm.get(field)?.disable();
       }
     }
   }
 
   buscarNimaGestor(fechaAceptacion: any, poseedor: any, emitEvent: boolean = false) {
     this.spinnerSrv.loadingShow();
    const params = new HttpParams().set('page', '0').set('size', '100');
    this.http.get<any>(this.listaGestoresByUser, { params }).subscribe({
      next: (response: any) => {
        const datos = Array.isArray(response) ? response : (response?.datos ?? []);
        this.nimaGestorArray = (datos ?? []).map((item: any) => {
          const gestor = item?.gestorResiduo ?? item?.gestoresResiduos ?? item;
          return {
            id: gestor?.id ?? item?.id,
            nima: gestor?.nima ?? item?.nima,
            razonSocial: gestor?.razonSocial ?? gestor?.obRazonSocial ?? item?.razonSocial ?? item?.obRazonSocial,
            centro: gestor?.centro ?? gestor?.denominacionCentro ?? item?.centro ?? item?.denominacionCentro,
          };
        }).filter((g: any) => !!g?.id);

        this.setItemSelected('nimaGestor', 'nima', this.nimaGestorArray, emitEvent);
        this.spinnerSrv.loadingHide();
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
   }
 
   buscarNimaPoseedor(fechaAceptacion: any, nimaGestor: any, emitEvent: boolean = false) {
    const fecha = fechaAceptacion ? moment(new Date(fechaAceptacion)).format('YYYY-MM-DD') : undefined;
    const gestorId = nimaGestor?.id ?? nimaGestor?.gestorId ?? nimaGestor?.idGestor;
    if (!fecha || !gestorId) {
      this.nimaPoseedorArray = [];
      this.setItemSelected('poseedor', 'id', this.nimaPoseedorArray, emitEvent);
      return;
    }

     const currentRequestSeq = ++this.poseedoresRequestSeq;
     this.spinnerSrv.loadingShow();
    this.aportacionDiAcuerdosGestoresService.poseedores(gestorId, fecha).subscribe({
      next: (res) => {
        this.spinnerSrv.loadingHide();
        if (currentRequestSeq !== this.poseedoresRequestSeq) {
          return;
        }
        this.nimaPoseedorArray = res ?? [];
        this.setItemSelected('poseedor', 'id', this.nimaPoseedorArray, emitEvent);

        // In initial loads we often use emitEvent=false; force LER refresh once poseedor is set.
        const selectedPoseedor = this.modelForm.get('poseedor')?.value;
        if (selectedPoseedor) {
          this.buscaCodigoLer(
            this.modelForm.value?.fechaAceptacion,
            this.modelForm.value?.nimaGestor,
            selectedPoseedor,
            false
          );
        }
      },
      error: () => {
        this.spinnerSrv.loadingHide();
        if (currentRequestSeq !== this.poseedoresRequestSeq) {
          return;
        }
      },
    });
   }
 
   buscaCodigoLer(fechaAceptacion: any, gestorResiduo: any, poseedor: any, emitEvent: boolean = true) {
    const fechaOrigen =
      fechaAceptacion ??
      this.modelForm?.get('fechaAceptacion')?.value ??
      this.aportacion?.fechaAceptacion;
    const gestorOrigen =
      gestorResiduo ??
      this.modelForm?.get('nimaGestor')?.value ??
      this.aportacion?.gestorResiduo ??
      this.aportacion?.poseedorOrGestor?.gestorResiduo;
    const poseedorOrigen =
      poseedor ??
      this.modelForm?.get('poseedor')?.value ??
      this.aportacion?.poseedor ??
      this.aportacion?.poseedorOrGestor?.poseedor;

    const fecha = fechaOrigen ? moment(new Date(fechaOrigen)).format('YYYY-MM-DD') : undefined;
    const gestorId = gestorOrigen?.id ?? gestorOrigen?.gestorId ?? gestorOrigen?.idGestor;
    const poseedorId = poseedorOrigen?.id ?? poseedorOrigen?.poseedorId ?? poseedorOrigen?.idPoseedor;

    if (fecha && gestorId && poseedorId) {
      const filtroNimaPoseedor = {
        fechaAceptacion: fecha,
        gestorId,
        poseedorId,
        origenSDDRCA: this.modelForm.get('esAportacionSDDRCA')?.value,
      };
      const currentRequestSeq = ++this.codigoLerRequestSeq;
       this.spinnerSrv.loadingShow();
      this.aportacionDiAcuerdosGestoresService.codigoLer(filtroNimaPoseedor).subscribe({
         next: (res) => {
          this.spinnerSrv.loadingHide();
          if (currentRequestSeq !== this.codigoLerRequestSeq) {
            return;
          }
          this.codigoLerArray = res ?? [];
          this.ensureCurrentCodigoLerVisibleForEstado10();
          this.codigosLerEndpoint = this.codigoLerArray;
           this.setItemSelected('codigoLer', 'id', this.codigoLerArray, emitEvent);
         },
         error: () => {
          this.spinnerSrv.loadingHide();
          if (currentRequestSeq !== this.codigoLerRequestSeq) {
            return;
          }
          this.codigoLerArray = [];
          this.codigosLerEndpoint = [];
         },
       });
     } else {
       const hasCurrentCodigoLer = !!this.modelForm?.get('codigoLer')?.value;
       const changedByUser =
         !!this.modelForm?.get('fechaAceptacion')?.dirty ||
         !!this.modelForm?.get('nimaGestor')?.dirty ||
         !!this.modelForm?.get('poseedor')?.dirty;

       if (changedByUser || !hasCurrentCodigoLer) {
         this.codigoLerArray = [];
         this.codigosLerEndpoint = [];
         this.gestionArray = [];
       } else {
         this.ensureCurrentCodigoLerVisibleForEstado10();
       }
     }
   }

  compareById = (left: any, right: any): boolean => {
    const leftId = left?.id ?? left;
    const rightId = right?.id ?? right;
    return leftId === rightId;
  };

  private ensureCurrentCodigoLerVisibleForEstado10(): void {
    const currentCodigoLer = this.modelForm?.get('codigoLer')?.value;
    if (this.getCurrentEstadoId() !== 10 && !this.isBidonCodigoLer(currentCodigoLer)) {
      return;
    }

    const currentId = currentCodigoLer?.id;
    if (!currentId) {
      return;
    }

    const exists = this.codigoLerArray?.some((item: any) => item?.id === currentId);
    if (!exists) {
      this.codigoLerArray = [...(this.codigoLerArray ?? []), currentCodigoLer];
    }
  }
 
   //buscarGestorResiduos() {
   //  const filtroResiduo: ResiduoEnvaseFilterDTO = {};
   //  this.spinnerSrv.loadingShow();
   //  this.gestorResiduos
   //    .findAll8(filtroResiduo, { page: 0, size: 1000 })
   //    .subscribe({
   //      next: (res) => {
   //        this.residuoArray = res?.datos ?? [];
   //        this.setItemSelected('gestorResiduo', 'id', this.residuoArray, false);
   //        this.updateDisableField('gestorResiduo');
   //        this.spinnerSrv.loadingHide();
   //      },
   //      error: () => {
   //        this.spinnerSrv.loadingHide();
   //      },
   //    });
   //}
 
   valueChangeCodigoLer() {
     this.modelForm.get('codigoLer')?.valueChanges.subscribe((value: any) => {
      if (this.modelForm.get('codigoLer')?.dirty) {
        this.codigoLerLockedByUser = true;
      }
       if (value) {
         if (!this.creacionResiduoEnvase && (this.aportacion.poseedorOrGestor.estado.id === 7 || this.aportacion.poseedorOrGestor.estado.id === 1 || this.aportacion.estado === 7 || this.aportacion.estado === 1 || this.aportacion.poseedorOrGestor.estado.id === 10)) {
           if (this.modelForm.get('codigoLer')?.dirty) {
             this.modelForm.controls['operacionGestion'].reset();
           }
         }
         this.defaultOperacionesGestionParameters = {codigoLer: [value?.id ?? null], poseedores: true};
         this.updateList = !this.updateList;
         // this.buscarOperacionesGestion();
         this.cargarTarifaImporte();
       } else {
         this.defaultOperacionesGestionParameters = {codigoLer: [null], poseedores: true};
         this.gestionArray = [];
         this.modelForm.controls['operacionGestion'].reset();
       }
     });
 
     // Forzar carga inicial si hay valor preestablecido
     const initialLer = this.modelForm.get('codigoLer')?.value;
     if (initialLer) {
       this.defaultOperacionesGestionParameters = {codigoLer: [initialLer.id ?? null], poseedores: true};
       this.updateList = !this.updateList;
       // this.buscarOperacionesGestion();
     }
 
   }
 
   buscarOperacionesGestion() {
     const { backendFilter, page, size } = this.getBackendFilter();
     this.spinnerSrv.loadingShow();
     this.operacionGestionControllerService
       .findByCodigoOperacion(backendFilter, { page: page, size: size })
       .subscribe({
         next: (res) => {
           if (res) {
             this.gestionArray = res?.datos ?? [];
             this.creacionResiduoEnvase = true;
             this.setItemSelected('operacionGestion', 'id', this.gestionArray, false);
             this.updateDisableField('operacionGestion');
           }
           this.spinnerSrv.loadingHide();
           this.creacionResiduoEnvase = false;
         },
         error: () => {
           this.spinnerSrv.loadingHide();
         },
       });
   }
 
   valueChangeCantidadGest() {
     this.modelForm.get('cantidadGestionada')?.valueChanges.subscribe((value: any) => {
       if (value) {
         const tarifa = this.modelForm.get('tarifaAplicada')?.value;
         const importeTotal = Math.round(tarifa * value * 100) / 100;
         this.modelForm.get('importeTotal')?.setValue(importeTotal);
       } else {
         this.modelForm.get('importeTotal')?.setValue(0);
       }
     });
   }
 
   cargarTarifaImporte(){
     // No calcular la tarifa cuando la aportación está en estado 5 (Cancelada) para evitar el error del backend
     if(this.modelForm.get('codigoLer')?.value && this.getCurrentEstadoId() !== 5){
      const gestorId = this.modelForm.get('nimaGestor')?.value?.id;
      const operacionGestionId = this.modelForm.get('operacionGestion')?.value?.id;
      
      const aporTarifaImporte = {
        codigoLerID: { id: this.modelForm.get('codigoLer')?.value?.id },
        gestor: { id: gestorId },
        operacionGestion: { id: operacionGestionId },
        anio: new Date(this.modelForm.get('fechaAceptacion')?.value).getFullYear(),
        cantidad: this.modelForm.get('cantidadGestionada')?.value ? this.modelForm.get('cantidadGestionada')?.value : 0
      };
      this.aportacionDiAcuerdosGestoresService.actualizarImporte(aporTarifaImporte)
      .subscribe({
          next: (res) => {
            if(res){
              this.modelForm.get('importeTotal')?.setValue(res.importeAportacion);
              this.modelForm.get('tarifaAplicada')?.setValue(res.importeTarifa);
            }
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
       this.modelForm.get('tarifaAplicada')?.setValue(0);
     }
     
   }
 
   private getBackendFilter() {
     const backendFilter: CodigoOperacionFilterDTO = {
       codigoLer: [this.modelForm.get('codigoLer')?.value?.id],
       poseedores: true
     };
     const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
 
     return { backendFilter, page, size: this.pageSize };
   }
 
   private setItemSelected(
     controlName: string,
     propertyName: string,
     items: any[],
     emitEvent: boolean
   ) {
     let selectedItem = null;
    const currentValue = this.modelForm.get(controlName)?.value;
    const currentValueId = currentValue?.[propertyName] ?? null;
     if (this.modelForm.value[controlName]) {
       if (
         typeof this.modelForm.value[controlName] == 'object' &&
         this.modelForm.value[controlName][propertyName]
       ) {
         selectedItem = items.find(
           (item) =>
             this.modelForm.value[controlName][propertyName] ==
             item[propertyName]
         );
       } else {
         selectedItem = items.find(
           (item) => this.modelForm.value[controlName] == item[propertyName]
         );
       }
     }

    // Prevent automatic refreshes from changing user-selected codigoLer to another value.
    if (
      controlName === 'codigoLer' &&
      currentValueId != null &&
      selectedItem &&
      selectedItem[propertyName] !== currentValueId
    ) {
      return;
    }

    if (
      controlName === 'codigoLer' &&
      this.codigoLerLockedByUser &&
      currentValueId != null
    ) {
      if (!selectedItem || selectedItem[propertyName] !== currentValueId) {
        return;
      }
    }

    // Avoid overwriting values already loaded in the form while async lists are still refreshing.
    if (selectedItem) {
      this.modelForm.controls[controlName].patchValue(selectedItem, {
        emitEvent: emitEvent,
      });
      return;
    }

    if (!currentValue) {
      this.modelForm.controls[controlName].patchValue(null, {
        emitEvent: emitEvent,
      });
    }
   }
 
   closeDialog(): void {
     this.dialogRef.close();
   }
 
   buttonSaveData(estadoId: any) {
     this.modelForm.markAllAsTouched();
     this.modelForm.updateValueAndValidity();
 
     if (this.aportacion?.documento == null) {
       if (this.documento == undefined || this.documento == null) {
         this.snackBarSrv.showSnackBar('Adjunte documento', 'error');
         return;
       }
     }
 
     if (this.modelForm.valid) {
      //  const todayDate = new Date();
      //  const fechaAceptacion = new Date(this.modelForm.get('fechaAceptacion')?.value);
      //  if(fechaAceptacion > todayDate){
      //    this.snackBarSrv.showSnackBar(
      //      'La fecha de aceptación no puede ser posterior a la fecha actual.',
      //      'error'
      //    );
      //    return;
      //  }
       const cantidadGest = this.modelForm.get('cantidadGestionada')?.value;
        //  if(cantidadGest && cantidadGest < 100){
        //    swal.fire({
        //      text: 'Por favor, verifique que el valor introducido en la cantidad neta gestionada es correcto y está en las unidades correspondientes (Kg)',
        //      icon: 'question',
        //      showDenyButton: true,
        //      showCancelButton: false,
        //      confirmButtonText: 'Guardar',
        //      denyButtonText: 'Cancelar',
        //      allowOutsideClick: false,
        //    }).then((result: any) => {
        //      if (result.isConfirmed) {
        //        this.saveData(estadoId);
        //      }
        //    });
         //}else{
           this.saveData(estadoId);
         //}
     }else{
       this.snackBarSrv.showSnackBar('Debe completar los campos obligatorios', 'error');
     }
   }
 
   saveData(estadoId: any) {
     const aportacionPayload: AportacionDIAcuerdosGestoresPayloadDTO = this.getAportacionPayload(estadoId);
     let request, successMsg: string, errorMsg: string;
     if (this.aportacion?.id) {
       request = this.aportacionDiAcuerdosGestoresService.editById2(
         this.aportacion.id,
         aportacionPayload,
         this.documento
       );
       successMsg = 'La aportación DI/FS se ha editado correctamente';
       errorMsg = 'Ha ocurrido un error al editar la aportación DI/FS';
     } else {
       if (!this.documento) {
         this.snackBarSrv.showSnackBar(
           'Debe seleccionar un documento',
           'error'
         );
         return;
       }
 
       request = this.aportacionDiAcuerdosGestoresService.create1(
         aportacionPayload,
         this.documento
       );
       successMsg = 'La aportación DI/FS se ha creado correctamente';
       errorMsg = 'Ha ocurrido un error al crear la nueva aportación DI/FS';
     }
 
     this.spinnerSrv.loadingShow();
     request.subscribe({
       next: (response) => {
         this.spinnerSrv.loadingHide();
         this.dialogRef.close(true);
         this.snackBarSrv.showSnackBar(successMsg, 'success');
       },
       error: () => {
         if(estadoId != 7 && !this.gestorEnvaloraCanEditAportacion()){
           this.aportacion.poseedorOrGestor.estado.id = 1;
         }
         this.spinnerSrv.loadingHide();
       },
     });
   }
 
   showClearButton(formName: string): boolean {
     return this.modelForm.get(formName)?.value !== null;
   }
 
   clearSelection(event: Event, formName: string) {
     event.stopPropagation();
     this.modelForm.get(formName)?.setValue(null);
   }
 
   controlHasError(controlName: string, errorName: string) {
     return (
       this.modelForm.controls[controlName].hasError(errorName) &&
       this.modelForm.controls[controlName].touched
     );
   }
 
   attachAdjunto(archivo: File | null): void {
     if (archivo) {
       if (archivo.size === 0) {
         this.snackBarSrv.showSnackBar(
           'No se puede subir un fichero vacío',
           'error'
         );
       } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
         this.snackBarSrv.showSnackBar(
           'El fichero supera el tamaño máximo permitido de 12 MB',
           'error'
         );
       } else {
         this.documento = archivo;
       }
     }
   }

   descargarDoc(documento: any) {
    this.spinnerSrv.loadingShow();
    this.aportacionDiAcuerdosGestoresService.downloadDoc(this.aportacion.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, documento.nombre);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }
 
  descargarPrefactura(documento: any) {
      this.spinnerSrv.loadingShow();
      this.aportacionDiAcuerdosGestoresService.downloadDocPrefactura(this.aportacion.id).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha descargado la prefactura correctamente',
            'success'
          );
          this.downloadService.downloadBlob(response, documento.nombre);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
        },
      });
   }
 
   canAccessEditEstado(): boolean {
     return this.aportacion?.poseedorOrGestor.estado || this.aportacion?.estado ?.id === 1;
   }
 
   canAccessEditByRol(): boolean {
    if (this.isCanceladaState()) {
      return false;
    }
    if (this.isRevisadaState()) {
      return false;
    }
    if (this.isCorreccionEnvaloraState()) {
      return this.gestorEnvaloraCanEditAportacion();
    }
     if (this.isAiGestorSoloReadOnly()) {
       return false;
     }
     return this.authService.can('acuerdo-indirecto-di-detalle', 'access-update');
   }
 
   canSaveAll(): boolean {
     if (this.isCorreccionEnvaloraState() && !this.gestorEnvaloraCanEditAportacion()) {
       return false;
     }

     if (!this.edicion) {
       return this.authService.can('acuerdo-indirecto-di', 'create') && this.canAccessEditEstado();
     }

     if (this.canAccessEditByRol() && this.canAccessEditEstado()) {
       return this.aportacion.creadoPor == this.authService.getCurrentUserMail();
     }

     return false;
   }
 
   canAccessAcceptAportacion() {

     if (this.isAiGestorSoloReadOnly()) {
       return false;
     }
     const resultAccept = this.authService.can('acuerdo-indirecto-di', 'update-accept');
     const estado2 = this.aportacion.poseedorOrGestor.estado && (this.aportacion.poseedorOrGestor.estado.id === 8 || this.aportacion.poseedorOrGestor.estado.id === 5|| this.aportacion?.estado === 8 || this.aportacion?.estado === 5);
     return resultAccept && estado2;
   }
 
   canAccessCancelAportacion() {

     if (this.isAiGestorSoloReadOnly()) {
       return false;
     }
     const resultCancel = this.authService.can('acuerdo-indirecto-di', 'update-cancel');
     const estado2 = this.aportacion.poseedorOrGestor.estado && (this.aportacion.poseedorOrGestor.estado.id === 3 || this.aportacion.poseedorOrGestor.estado.id === 7 || this.aportacion.poseedorOrGestor.estado.id === 8 || this.aportacion?.estado === 3 || this.aportacion?.estado === 7 || this.aportacion?.estado === 8);
     return resultCancel && estado2;
   }
   
   canUpdateEstadoPdteRevision(){
     //const estado7 = this.aportacion.poseedorOrGestor.estado && this.aportacion.poseedorOrGestor.estado.id === 7; //Pdte revision
     //return estado7;
     return this.canAccessRevisarAportacion();
   }
 
  private getCurrentEstadoId(): number | null {
    const estadoId = this.aportacion?.poseedorOrGestor?.estado?.id ?? this.aportacion?.estado?.id ?? this.aportacion?.estado;
    return typeof estadoId === 'number' ? estadoId : null;
  }

   canAccessRevisarAportacion(){
    if (this.isCanceladaState()) {
      return false;
    }
    if (this.isRevisadaState()) {
      return false;
    }
    if (this.isAiGestorSoloReadOnly()) {
      return false;
    }
    const hasAutofactRole = this.canViewRol('AI-APORT-AUTOFACT');
    const estado7 = this.getCurrentEstadoId() === 7; // Pdte revision
     return hasAutofactRole && estado7;
   }
 
   canAccessDeleteAportacion(){
    if (this.isCanceladaState()) {
      return false;
    }
    if (this.isRevisadaState()) {
      return false;
    }
    if (this.isAiGestorSoloReadOnly()) {
      return false;
    }
    const resultDelete = this.authService.can('acuerdo-indirecto-di', 'delete');
    const estado7 = this.getCurrentEstadoId() === 7; // Pdte revision
     return resultDelete && estado7;
   }

  isPdteRevisionState(): boolean {
    const estadoId = this.getCurrentEstadoId();
    const estadoDescripcion = (
      this.aportacion?.poseedorOrGestor?.estado?.descripcion ??
      this.aportacion?.estado?.descripcion ??
      ''
    )
      .toString()
      .trim()
      .toLowerCase();

    return estadoId === 7 || estadoDescripcion === 'pdte de revisión' || estadoDescripcion === 'pendiente de revisión';
  }

  isRevisadaState(): boolean {
    const estadoId = this.getCurrentEstadoId();
    const estadoDescripcion = (
      this.aportacion?.poseedorOrGestor?.estado?.descripcion ??
      this.aportacion?.estado?.descripcion ??
      ''
    )
      .toString()
      .trim()
      .toLowerCase();

    return estadoId === 8 || estadoDescripcion === 'revisada';
  }

  isCanceladaState(): boolean {
    const estadoId = this.getCurrentEstadoId();
    const estadoDescripcion = (
      this.aportacion?.poseedorOrGestor?.estado?.descripcion ??
      this.aportacion?.estado?.descripcion ??
      ''
    )
      .toString()
      .trim()
      .toLowerCase();

    return estadoId === 3 || estadoDescripcion === 'cancelada';
  }

  isCorreccionEnvaloraState(): boolean {
    return this.getCurrentEstadoId() === 10;
  }

  isOnlyBackState(): boolean {
    const estadoId = this.getCurrentEstadoId();
    const estadoDescripcion = (
      this.aportacion?.poseedorOrGestor?.estado?.descripcion ??
      this.aportacion?.estado?.descripcion ??
      ''
    )
      .toString()
      .trim()
      .toLowerCase();

    return (
      estadoId === 2 ||
      estadoId === 4 ||
      estadoDescripcion === 'prefacturada' ||
      estadoDescripcion === 'enviada'
    );
  }

  isOnlyBackForEnvaloraGestorPdteRevision(): boolean {
    return this.esGestorEnvalora() && this.isPdteRevisionState();
  }
 
   acceptAportacion() {
     this.spinnerSrv.loadingShow();
     this.aportacionDiAcuerdosGestoresService
       .aceptarAportacion(this.aportacion.id)
       .subscribe({
         next: () => {
           this.spinnerSrv.loadingHide();
           this.snackBarSrv.showSnackBar(
             'Se ha aceptado la aportación correctamente',
             'success'
           );
           this.dialogRef.close(true);
         },
         error: (err) => {
           this.dialogRef.close(true);
           console.log(err);
         },
       });
   }
 
   openModalMotivoCancelAportacion() {
     const dialogRef = this.dialog.open(
      ManagersAgreementsContributionsDisDeclineDialogComponent,
       {
         width: '750px',
         maxWidth: '95%',
         maxHeight: '95vh',
         data: {
           info: this.aportacion,
         },
         disableClose: true,
       }
     );
     dialogRef.afterClosed().subscribe((result) => {
       if (result) {
         this.dialogRef.close(true);
       }
     });
   }
 
 
 
   openModalAyuda() {
     const dialogRef = this.dialog.open(
      ManagersAgreementsContributionsDisImageDialogComponent,
       {
         width: '98%',
         maxWidth: '98%',
         maxHeight: '95vh',
         disableClose: true,
       }
     );
 
     dialogRef.afterClosed().subscribe((result) => {
     });
   }
 
   vistaPreviaAportacion(element: any) {
    const dialogRef = this.dialog.open(ManagersAgreementsContributionsDisPreviewDialogComponent, {
       width: '98%',
       maxWidth: '98%',
       maxHeight: '95vh',
       data: element,
       disableClose: true,
     });
   }
 
   esAportacionSDDRChange(){
     if (this.modelForm.get('esAportacionSDDRCA')?.value) {
       this.aportacion.origen = 'SDDRCA';
     } else {
       this.aportacion.origen = 'POSEEDOR';
     }
     if(this.aportacion.poseedor){
       //buscar gestores en funcion de si es Aportacion del SDDR o no
       this.buscarNimaGestor(
         this.modelForm.value?.fechaAceptacion,
         this.aportacion.poseedor,
         true
       );
     }else{
       //buscar poseedores en funcion de si es Aportacion del SDDR o no
       this.buscarNimaPoseedor(
         this.modelForm.value?.fechaAceptacion,
         this.aportacion.gestorResiduo,
         true
       );
     }
   }
   esPdteRevision(){
     return this.aportacion?.poseedorOrGestor.estado || this.aportacion?.estado .id === 7;
   }
 
   buscarFechaLimite() {
     this.parametrosControllerService.findAll7().subscribe({
       next: (parametros: any) => {
         const parametro = parametros.find((p: any) => p.id === 1);
         if (parametro?.valor) {
           const [day, month, year] = parametro.valor.split('/');
           this.fechaLimite = new Date(+year, +month - 1, +day); // mes empieza en 0
         } else {
           this.fechaLimite = undefined;
         }
         this.modelForm.get('fechaAceptacion')?.updateValueAndValidity();
 
       },
       error: (err) => {
         console.error("Error al obtener parámetros", err);
       }
     });
   }
 
   customValidator() {
     return (control: { value: any }) => {
       const value = control.value;
      if (!value) {
         return null;
       }

      const fechaIngresada = moment(value);
      if (!fechaIngresada.isValid()) {
        return null;
      }

      if (fechaIngresada.isAfter(moment(), 'day')) {
        return { fechaPosteriorHoy: true };
      }

      if (!this.fechaLimite) {
        return null;
      }

      return fechaIngresada.toDate() < this.fechaLimite ? { fechaInvalida: true } : null;
     };
   }

  private isFechaAceptacionPosteriorHoy(value: any): boolean {
    if (!value) {
      return false;
    }
    const fechaAceptacion = moment(value);
    return fechaAceptacion.isValid() && fechaAceptacion.isAfter(moment(), 'day');
  }
 
  onInput(controlName: string, event: any) {
     const control = this.modelForm.get(controlName)
 
     control?.markAsTouched();
     control?.markAsDirty();
   }
   openConfirmacionEliminar(): void {
     Swal.fire({
       text: `¿Está seguro de eliminar este registro?
               El documento se eliminará de ENVANET y no podrá volver a consultarlo.`,
       icon: 'question',
       showDenyButton: true,
       showCancelButton: false,
       confirmButtonText: 'Sí',
       denyButtonText: 'No',
       allowOutsideClick: false,
     }).then((result: any) => {
       if (result.isConfirmed) {
         this.eliminarAportacion();
       }
     });
   }
 
   eliminarAportacion() {
     if (this.aportacion?.id) {
       this.spinnerSrv.loadingShow();
       this.aportacionDiAcuerdosGestoresService
         .deleteById2(this.aportacion?.id)
         .subscribe({
           next: (value: any) => {
             this.spinnerSrv.loadingHide();
             this.snackBarSrv.showSnackBar(
               `La aportación DI se ha eliminado correctamente.`,
               'success'
             );
             this.dialogRef.close(true);
           },
           error: (err: { message: any }) => {
             this.spinnerSrv.loadingHide();
           },
         });
     }
   }
 
     getAportacionPayload(estadoId: any){
     const formValue = this.modelForm.value;
     const aportacionPayload: AportacionDIAcuerdosGestoresPayloadDTO = formValue;
     //aportacionPayload.gestorResiduo = formValue.nimaGestor;
     if(formValue.nimaGestor.id != null && formValue.nimaGestor.id != undefined){
       aportacionPayload.gestorResiduo = formValue.nimaGestor;
       //aportacionPayload.nimaGestor = '';
     }else{
       //aportacionPayload.nimaGestor = formValue.nimaGestor.nima;
     }
     if (aportacionPayload.estado !== undefined && estadoId !== null) {
       aportacionPayload.estado!.id = estadoId;
     }
     aportacionPayload.fechaAceptacion = moment(aportacionPayload.fechaAceptacion).format('YYYY-MM-DD');
     if(!aportacionPayload.documentoIdentificacion){
       aportacionPayload.documentoIdentificacion = this.modelForm?.get("documentoIdentificacion")?.value;
     }
    //  if(!aportacionPayload.esAportacionSDDRCA){
    //    aportacionPayload.esAportacionSDDRCA = false;
    //  }
 
    //  if (aportacionPayload.esAportacionSDDRCA) {
    //    (aportacionPayload as any).origen = 'SDDRCA';
    //  } else {
    //    (aportacionPayload as any).origen = 'POSEEDOR';
    //  }
 
  //  if(formValue.subirDocumentoOnEdit === true){
  //      aportacionPayload.nuevoDocumento = true;
  //    }
     return aportacionPayload;
   }
 
     buttonRevisarAportacion(){
     this.modelForm.markAllAsTouched();
     this.modelForm.updateValueAndValidity();
 
    if (this.modelForm.valid) {
      const fechaAceptacionValue = this.modelForm.get('fechaAceptacion')?.value;
      if (this.isFechaAceptacionPosteriorHoy(fechaAceptacionValue)) {
         this.snackBarSrv.showSnackBar(
           'La fecha de aceptación no puede ser posterior a la fecha actual.',
           'error'
         );
         return;
       }
     }
 
     if (this.modelForm.valid) {
       const cantidadGest = this.modelForm.get('cantidadGestionada')?.value;
      //  if(cantidadGest && cantidadGest < 100){
      //    swal.fire({
      //      text: 'Por favor, verifique que el valor introducido en la cantidad neta gestionada es correcto y está en las unidades correspondientes (Kg)',
      //      icon: 'question',
      //      showDenyButton: true,
      //      showCancelButton: false,
      //      confirmButtonText: 'Guardar',
      //      denyButtonText: 'Cancelar',
      //      allowOutsideClick: false,
      //    }).then((result: any) => {
      //      if (result.isConfirmed) {
      //        this.revisarAportacion();
      //      }
      //    });
      //  }else{
         this.revisarAportacion();
       //}
     }else{
       this.snackBarSrv.showSnackBar('Debe completar los campos obligatorios', 'error');
     }
   }
 
     revisarAportacion(){
     const aportacionPayload: AportacionDIAcuerdosGestoresPayloadDTO = this.getAportacionPayload(null);
       this.spinnerSrv.loadingShow();
       //this.snackBarSrv.showSnackBar('No hay servicio', 'error');
      this.aportacionDiAcuerdosGestoresService.revisarAportacion(this.aportacion.id, aportacionPayload).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.dialogRef.close(true);
          this.snackBarSrv.showSnackBar('La aportación DI se ha revisado correctamente', 'success');
        },
        error: (error: any) => {
          const backendMessage = error?.error?.arguments?.[0]
          this.snackBarSrv.showSnackBar(
            backendMessage,
            'error'
          );
          this.spinnerSrv.loadingHide();
        },
      });
   }
 
   esGestorEnvalora(){
     return (this.canViewRol('AI-ENV-GEST') || this.canViewRol('AI-ENV-CONS'));
   }
 
     canViewRol(rol: string): boolean {
     return this.authService.hasCurrentUserRole(rol);
   }

   isAiGestorSoloReadOnly(): boolean {
     const hasAiGestorRole = this.canViewRol('AI-GESTOR') || this.canViewRol('AI_GESTOR');
     const hasAutofactRole = this.canViewRol('AI-APORT-AUTOFACT');
     const hasEditTotalEnvGest = this.canViewRol('AI-APORT-EDIC-TOTAL-ENV-GEST');
     const hasEnvAdminRole = this.canViewRol('AI-ENV-GEST') || this.canViewRol('AI-ENV-CONS');

     return hasAiGestorRole && !hasAutofactRole && !hasEditTotalEnvGest && !hasEnvAdminRole;
   }

     isAutofactRevisadaReadOnly(): boolean {
       const isAutofact = this.canViewRol('AI-APORT-AUTOFACT');
       const estadoId = this.aportacion?.poseedorOrGestor?.estado?.id ?? this.aportacion?.estado?.id ?? this.aportacion?.estado;
       const estadoDescripcion = (
         this.aportacion?.poseedorOrGestor?.estado?.descripcion ??
         this.aportacion?.estado?.descripcion ??
         ''
       )
         .toString()
         .trim()
         .toLowerCase();

       return isAutofact && (estadoId === 8 || estadoDescripcion === 'revisada');
     }
 
   gestorEnvaloraCanEditAportacion() {
    return this.puedeEditarAportacionEstadoCorrecionEnvalora() && this.isCorreccionEnvaloraState();
   }
 
   puedeEditarAportacionEstadoCorrecionEnvalora() {
    return this.canViewRol('AI-APORT-EDIC-TOTAL-ENV-GEST');
   }
 
   isEdicionMode(): boolean {
     return !!(this.aportacion && this.aportacion?.id > 0 && !this.aportacion?.externa);
   }

  private isNoUipathPlatform(): boolean {
    const plataformaOrigenRaw =
      this.aportacion?.plataformaOrigen ??
      this.aportacion?.plataforma_origen ??
      this.aportacion?.origenPlataforma ??
      this.aportacion?.plataforma;

    const plataformaOrigenCode =
      typeof plataformaOrigenRaw === 'number'
        ? plataformaOrigenRaw
        : Number(plataformaOrigenRaw?.id ?? plataformaOrigenRaw?.codigo ?? plataformaOrigenRaw);

    return plataformaOrigenCode === 2 || plataformaOrigenCode === 3;
  }

  showUipathData(): boolean {
    return !this.isNoUipathPlatform();
  }
 
   fieldDiffers(fieldName: string): boolean {
     if (!this.isEdicionMode() || !this.uipathForm) return false;
     switch (fieldName) {
       case 'documentoIdentificacion': {
         const left = this.modelForm.get('documentoIdentificacion')?.value;
         const right = this.uipathForm.get('documentoIdentificacionUipath')?.value;
         if (!left && !right) return false;
         return this.normalizeString(left) !== this.normalizeString(right);
       }
       case 'fechaAceptacion': {
         const left = this.modelForm.get('fechaAceptacion')?.value;
         const right = this.uipathForm.get('fechaAceptacionUipath')?.value;
         if (!left && !right) return false;
         if (!left || !right) return true;
         return moment(left).format('YYYY-MM-DD') !== moment(right).format('YYYY-MM-DD');
       }
       case 'poseedor': {
         const left = this.modelForm.get('poseedor')?.value;
         const right = this.uipathForm.get('poseedorUipath')?.value;
         if (!left && !right) return false;
         if (!left || !right) return true;

        const leftId = this.normalizeString(left?.id);
        const leftNima = this.normalizeString(left?.nima);

        const rightRef = this.aportacion?.poseedorReferenceUipath;
        const rightId = this.normalizeString(rightRef?.id);
        const rightNima = this.normalizeString(rightRef?.nima);

        if (leftId && rightId) {
          return leftId !== rightId;
        }

        if (leftNima && rightNima) {
          return leftNima !== rightNima;
        }

        const rightRaw = this.normalizeString(right);
        if (leftNima && rightRaw && !rightRaw.includes(' - ')) {
          return leftNima !== rightRaw;
        }

        const leftRazonSocial = this.normalizeString(left?.razonSocial ?? left?.obRazonSocial);
        const leftCentro = this.normalizeString(left?.denominacionCentro ?? left?.centro);
        const leftStr = `${leftNima}${leftRazonSocial ? ' - ' + leftRazonSocial : ''}${leftCentro ? ' - ' + leftCentro : ''}`;

        return this.normalizeString(leftStr) !== rightRaw;
       }
       case 'nimaGestor': {
         const left = this.modelForm.get('nimaGestor')?.value;
         const right = this.uipathForm.get('nimaGestorUipath')?.value;
         if (!left && !right) return false;
         if (!left || !right) return true;
         const leftStr = `${left.nima || ''}${left.razonSocial ? ' - ' + left.razonSocial : ''}${left.centro ? ' - ' + left.centro : ''}`;
         return this.normalizeString(leftStr) !== this.normalizeString(right);
       }
       case 'codigoLer': {
         const left = this.modelForm.get('codigoLer')?.value;
         const right = this.uipathForm.get('codigoLerUipath')?.value;
         if (!left && !right) return false;
         if (!left || !right) return true;
         const leftStr = `${left.tipoCodigo} - ${left.descripcion}`;
         return this.normalizeString(leftStr) !== this.normalizeString(right);
       }
       case 'operacionGestion': {
         const left = this.modelForm.get('operacionGestion')?.value;
         const right = this.uipathForm.get('operacionGestionUipath')?.value;
         if (!left && !right) return false;
         if (!left || !right) return true;
         const leftStr = `${left.codigo} - ${left.descripcion}`;
         return this.normalizeString(leftStr) !== this.normalizeString(right);
       }
       case 'cantidadGestionada': {
         const left = this.modelForm.get('cantidadGestionada')?.value;
         const right = this.uipathForm.get('cantidadGestionadaUipath')?.value;
         const leftEmpty = left === null || left === undefined || left === '';
         const rightEmpty = right === null || right === undefined || right === '';
         if (leftEmpty && rightEmpty) return false;
         if (leftEmpty || rightEmpty) return true;
         return Number(left) !== Number(right);
       }
       default:
         return false;
     }
   }
 
   private normalizeString(val: any): string {
     if (val === null || val === undefined) return '';
     return val.toString().trim().toLowerCase();
   }
 
   getFormControl(selectForm: any): FormControl {
     switch (selectForm) {
       case 'operacionGestion': {
         return this.modelForm.get('operacionGestion') as FormControl;
       }
       default: {
         return this.modelForm.get('') as FormControl;
       }
     }
   }
 
   getOperacionesGestionDescription(obj: any) {
     if (obj) {
       return obj.codigo + ' ' + obj.descripcion;
     }
     return '';
   }
 
   getOperacionesGestionObjectQuery(searchterm: string) {
     return {
       codigoOrDescripcion: `${searchterm}`,
     };
   }
 
   compararOperacionesGestion(o1: any, o2: any): boolean {
     return o1?.id === o2?.id;
   }
 }